var fontWeights = {
  normal: 400,
  semibold: 700,
  bold: 900
};
export default fontWeights;